import React from 'react';

export default function Button({ children, block = false, className = '', variant='primary', outline = false, ...props }) {

  return (
    <button className={`button button--medical button--${variant} ${outline ? 'button--outline' : ''} ${block ? 'button--block' : ''} ${className}`} {...props}>{children}</button>
  );
}